<template>
    <el-container :style="mainContentViewHeight" class="main-content">
        <el-aside width="200px" :style="leftContentViewHeight">
            <el-menu>
                <el-menu-item index="1">
                    <template slot="title">
                        <el-input
                                placeholder="请输入内容"
                                v-model="searchKey" @keyup.enter.native="getDict()">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </template>
                </el-menu-item>
                <el-menu-item v-for="(item,index) in dictCategoryList"
                              class="cate-item"
                              :key="item.id"
                              @click="handleCateClick(item)"
                              :index="getIndex(index)">{{item.businessName}}
                </el-menu-item>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header style="height: 56px">
                <span class="title">{{cateItem.businessName}}<span style="color: #434343" v-if="cateItem.businessCode">[{{cateItem.businessCode}}]</span></span>
                <el-button class="pull-right" @click="reloadCategory">刷新附件分类</el-button>
                <el-button type="primary" v-if="categoryId" style="margin-right: 10px" class="pull-right"
                           @click="addOrUpdateHandle('')">新增
                </el-button>
            </el-header>
            <el-main style="padding-top: 0">
                <el-table :data="dataList">
                    <el-table-column fixed prop="title" label="标题" width="250">
                    </el-table-column>
                    <el-table-column prop="englishName" label="待办名称(流程)" width="120">
                    </el-table-column>
                    <el-table-column prop="taskName" label="待办名称(显示)" width="120">
                    </el-table-column>
                    <el-table-column prop="taskDesc" label="待办描述" width="120">
                    </el-table-column>
                    <el-table-column prop="url" label="表单URL" width="120">
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" width="90">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            header-align="center"
                            align="center"
                            width="150"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
                            <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageIndex"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="totalPage"
                        layout="total, sizes, prev, pager, next, jumper">
                </el-pagination>
                <!-- 弹窗, 新增 / 修改 -->
                <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"
                               @refreshDataList="getDataList"></add-or-update>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import AddOrUpdate from "./audittaskform-edit";

    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                appId:'',
                dictCategoryList: [],
                dataList: [],
                searchKey: '',
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                cateItem: {id: ''},
                addOrUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate
        },
        computed: {
            isSupperAdmin: {
                get() {
                    return this.$store.state.user.supperAdmin === true || this.$store.state.user.supperAdmin === 'true'
                }
            },
            leftContentViewHeight: {
                get() {
                    return {height: this.mainContentViewHeight.minHeight}
                }
            },
            categoryId: {
                get() {
                    return this.cateItem.id
                }
            }
        },
        methods: {
            getAppId() {
                return this.appId
            },
            getIndex(index) {
                return "4" + index
            },
            reloadCategory() {
                let url = 'sys/config/reloadConfig2?method=audittaskform&appId=' + this.getAppId()
                this.$http.post(url, {}).then(({data}) => {
                    if (data.code == '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDict()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            handleCateClick(item) {
                this.cateItem = item
                this.getDataList()
            },
            getDataList() {
                let url = 'basic/taudittaskform/list'
                let params = {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'searchKey': '',
                    'filter': {businessType: this.cateItem.businessType}
                }
                this.$http.post(url, params).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows
                        this.totalPage = data.totalItemCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            getDict() {
                let params = {
                    filter: {
                        appId: this.getAppId()
                    }
                }
                console.log(params)
                this.$http.post('basic/taudittaskform/groupList', params).then(res => {
                    this.dictCategoryList = res.data.rows
                }).catch(err => {
                })
            }, // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id, this.cateItem.businessName, this.cateItem.businessType, this.getAppId())
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: this.$http.adornUrl('/basic/taudittaskform/delete?ids=' + id),
                        method: 'post',
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        },
        mounted() { 
            let appId=this.$route.query.appId
            if(appId==undefined){
                appId=this.$route.params.appId
            }
            this.appId=appId
            if(!this.appId){
                this.$showErrorPage('应用参数无效')
                return
            }
            this.getDict()
        }
    }
</script>

<style scoped lang="scss">
    .main-content {
        padding: 0px;
        padding-bottom: 0px;
    }

    .cate-item {
        height: 36px;
        line-height: 36px;
    }

    .el-header {
        border-bottom: 1px solid #dcdfe6;;
    }

    .el-aside {
        color: #333;
    }
</style>
